import React from 'react';
import FilmReelIcon from './FilmReelIcon';
import './BrandTitle.css';

function BrandTitle() {
  return (
    <div className="brand-wrapper">
      <div className="brand-title">
        <FilmReelIcon className="film-reel-icon" />
        <h1 className="brand-text">
          <span className="brand-q">Q</span>Reel<span className="quantum-dot"></span>
        </h1>
      </div>
      <div className="brand-tagline">Quantum Speed. Perfect Results.</div>
    </div>
  );
}

export default BrandTitle;